import { Content } from '@/lib';
import { VideoEmbed } from '@/components';
import styles from './YouTube.module.scss';
import { Row } from '../../Row';

export default function YouTube({ width, height, caption, embed }: Content.Embed) {
  return (
    <Row>
      <div className={styles.player}>
        <VideoEmbed embed={embed} caption={caption} width={width} height={height} />
      </div>
    </Row>
  );
}
